function initReveal() {
  const reveals = document.querySelectorAll('.bl-reveal');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.2 });

  reveals.forEach(el => observer.observe(el));
}

initReveal();
document.addEventListener('shopify:section:load', initReveal);